import React from 'react'
import CalendarDownload from '@berlitz/streamline-icons/lib/regular/01-Interface-Essential/21-Date-Calendar/CalendarDownload'
import Check from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/33-Form-Validation/Check'
import { WarningTriangle } from '@berlitz/icons'

export const DOWNLOAD_CAL_BTN_PROPS = {
  default: {
    label: 'Download calendar',
    disabled: false,
    btnType: 'default',
    icon: <CalendarDownload color="white" />,
    hasChanges: false,
  },
  downloaded: {
    label: 'Downloaded',
    disabled: true,
    btnType: 'default',
    icon: <Check color="white" />,
    hasChanges: false,
  },
  hasChanges: {
    label: 'Click to resync calendar',
    disabled: false,
    btnType: 'warning',
    icon: <WarningTriangle color="white" />,
    hasChanges: true,
  },
}

export const DOWNLOAD_CAL_MODAL_PROPS = {
  default: {
    icon: <CalendarDownload color="brand01" />,
    header: 'Calendar Download',
    desc: 'Select your preferred calendar',
  },
  hasChanges: {
    icon: <WarningTriangle color="warning" />,
    header: 'Schedule Has Changed',
    desc: 'Your previously downloaded calendar has changed.  Please download your revised calendar below.',
  },
}
